<template>
  <div id="app">
    <the-svg-supplier />
    <the-page-header />
    <!-- <novice-guide v-if="isNoviceGuideShow" @completed="onGuideHide" /> -->
    <div class="content">
      <keep-alive>
        <router-view
          class="main-view"
          v-if="$route.meta && $route.meta.keepAlive"
        />
      </keep-alive>
      <router-view
        class="main-view"
        v-if="!$route.meta || !$route.meta.keepAlive"
        @check-guide="checkGuide"
      />
    </div>
    <the-footer-bar v-if="hasFootBar" />
  </div>
</template>

<script>
import ThePageHeader from '@/components/the-page-header';
import TheSvgSupplier from '@/components/the-svg-supplier';
import getEnv from '@/utils/get-env';
import getQuery from '@/utils/get-query';
import { putUserGuide } from '@/api/user.js';
import { mapState } from 'vuex';
import { Dialog } from 'mand-mobile';
import TheFooterBar from '@/components/the-footer-bar';
import NoviceGuide from '@/components/novice-guide.vue';
export default {
  components: {
    ThePageHeader,
    TheSvgSupplier,
    TheFooterBar,
    NoviceGuide,
  },
  computed: {
    ...mapState({
      isLogin: state => state.isLogin,
      userInfo: state => state.userInfo,
      serviceUuid: state => state.serviceUuid,
    }),
    hasFootBar() {
      return ['/exchange', '/post', '/mine'].includes(this.$route.path);
    },
  },
  data() {
    return {
      isNoviceGuideShow: false,
    };
  },
  mounted() {
    const env = getEnv();
    if (env.isInIos) {
      document.addEventListener(
        'touchend',
        $event => {
          if (
            $event.target.tagName == 'INPUT' ||
            $event.target.tagName == 'TEXTAREA'
          ) {
            if (!$event.target.getAttribute('data-blurEvent')) {
              $event.target.setAttribute('data-blurEvent', 1);
              $event.target.addEventListener('blur', () => {
                window.scrollTo(0, 0);
                document.body.scrollTop = document.body.scrollHeight;
              });
            }
          }
        },
        false,
      );
    }
    const errMsg = getQuery('errMsg');
    if (errMsg) {
      Dialog.confirm({
        icon: 'icon-negative',
        iconSvg: true,
        title: errMsg,
        cancelText: this.$t('common.cancel'),
        confirmText: this.$t('mine.customerService'),
        onCancel: () => {
          window.history.replaceState(
            null,
            null,
            `${window.location.origin}/${window.location.hash}`,
          );
        },
        onConfirm: () => {
          window.open(
            `https://mixin.one/codes/${this.serviceUuid}`,
            '_blank',
            'noopener',
          );
        },
      });
    }
  },
  methods: {
    checkGuide() {
      if (
        this.isLogin &&
        this.$route.name === 'index' &&
        !this.userInfo.hasTraded &&
        !this.userInfo.isReadGuide
      ) {
        this.$store
          .dispatch('updateUserInfo')
          .then(() => {
            if (!this.userInfo.hasTraded && !this.userInfo.isReadGuide) {
              this.isNoviceGuideShow = true;
            }
          })
          .catch(() => {});
      }
    },
    onGuideHide() {
      this.isNoviceGuideShow = false;
      this.$store.commit('setUserInfo', {
        isReadGuide: true,
      });
      putUserGuide()
        .then(() => {
          this.$store.commit('setUserInfo', {
            isReadGuide: true,
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="stylus">
@import '~normalize.css/normalize.css';
@import '~flag-icon-css/css/flag-icon.min.css';

@font-face {
  font-family: 'customize din';
  font-style: bold;
  font-weight: 600;
  src: url('./fonts/din-medium.ttf');
}

@font-face {
  font-family: 'customize din';
  font-style: lighter;
  font-weight: 200;
  src: url('./fonts/din-regular.ttf');
}

html {
  touch-action: manipulation;
  height: 100vh;
  padding-top: constant(safe-area-inset-top); /* iOS 11.0 */
  padding-top: env(safe-area-inset-top); /* iOS 11.2 */
}

body {
  height: 100vh;
  font-size: font-body-normal;
  font-family: font-family-normal;
  line-height: 1.5;
  color: color-text-body;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
  -webkit-touch-callout: none;
  -moz-osx-font-smoothing: grayscale;
}

p, fieldset {
  margin: 0;
}

ol {
  margin: 0;
  padding: 0;

  li {
    list-style: none;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

th {
  font-weight: normal;
}

img {
  -webkit-user-select: none;
  user-select: none;
}

#app {
  position: relative;
  height: 100%;
  background: #fff;
}

#app > .content {
  position: absolute;
  absolute-pos(11.73vw, 0, 0, 0);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

#app > .content > .main-view {
  position: relative;
  height: 100%;
}

#app .num-font {
  font-family: 'customize din', sans-serif;
}

.row {
  display: flex;
}

.col {
  display: flex;
  flex-direction: column;
}

.col-center {
  @extend .col;
  justify-content: center;
  align-items: center;
}

.col-align-end {
  @extend .col;
  align-items: flex-end;
}

.row-justify {
  @extend .row;
  justify-content: space-between;
}

.row-center {
  @extend .row;
  justify-content: center;
  align-items: center;
}

.row-align-center {
  @extend .row;
  align-items: center;
}

.row-justify-center {
  @extend .row-justify;
  align-items: center;
}

.md-dialog-text a {
  color: color-text-link;
}

.md-dialog-title {
  word-wrap: break-word;
}

.md-toast-text {
  overflow: visible !important;
  white-space: normal !important;
}

a {
  color: color-text-link;
}
</style>
